module.exports = __webpack_public_path__ + "static/img/mtjz03.bd49233.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer/mtjz03.png
// module id = nk/j
// module chunks = 11